import { buildMetodiPagamentiMock } from "../../../mocks/pagamentiMock";

export const mockPagamentiProvider = {
  metodiPagamenti: async () => buildMetodiPagamentiMock(),

  associaMetodiPagamentoUtente: async () => ({
    message: "ok",
    statusCode: 202,
  }),
};

